import { dispatchCustomEventGlobally } from 'www/utils'
import { SCHEDULE_EVENTS } from 'www/modules/Schedule/constants'
import isHtmlElement from 'www/doctors.blocks/common/b-lpu-services/functions/isHtmlElement'

const handleToggleCalendar = ({ target }: MouseEvent) => {
  if (!isHtmlElement(target)) {
    return
  }

  try {
    const toggleButton = target.closest('.b-lpu-services__toggle-calendar')

    if (!toggleButton) {
      return
    }

    const wrapperRow = target.closest('.b-lpu-services__service-wrapper')

    if (!wrapperRow) {
      return
    }

    const container = wrapperRow.querySelector('.service-prices-schedule')

    if (!container) {
      return
    }

    const toggleButtonWrapList = [...wrapperRow.querySelectorAll('.b-lpu-services__toggle-calendar-wrap')]
    const wrapperRowButtonList = [...wrapperRow.querySelectorAll('.b-lpu-services__price')]

    container.classList.add('d-none')
    toggleButtonWrapList.forEach(el => el.classList.add('d-none'))
    wrapperRowButtonList.forEach(el => el.classList.remove('d-none'))

    dispatchCustomEventGlobally(SCHEDULE_EVENTS.hideAllToggleCalendar)
  } catch { /* Empty */ }
}

const addListenerToggleCalendar = () => {
  document.addEventListener('click', handleToggleCalendar)
}

export default addListenerToggleCalendar
